<template>
  <div class="w-100">
    <b-alert
      v-if="noContractsSelected"
      dismissible
      show
      variant="danger"
    >
      <h6>Verträge auswählen</h6>
      <p>Keine Verträge zum Vergleichen ausgewählt.</p>
    </b-alert>
    <u-loader v-if="isLoading" />
    <div v-else-if="ContractOne && ContractTwo">
      <button
        v-if="storedPdf"
        class="d-block"
        @click="
          storedPdf.download(
            `${ContractOne.EditionInfo.id.toString()}_${ContractTwo.EditionInfo.id.toString()}_${$moment(
              new Date(),
            ).format('YYYYMMDD')}.pdf`,
          )
        "
      >
        <i class="fas fa-file-pdf" /> Vergleich als PDF speichern
      </button>
      <button
        v-if="storedPdf"
        class="d-block"
        @click="
          downloadCsv(
            `${ContractOne.EditionInfo.id.toString()}_${ContractTwo.EditionInfo.id.toString()}_${$moment(
              new Date(),
            ).format('YYYYMMDD')}.csv`,
          )
        "
      >
        <i class="fas fa-file-csv" /> Vergleich als CSV speichern
      </button>

      <div class="w-100">
        <v-select
          v-if="storedPdf"
          v-model="selectedLanguage"
          :items="languages"
          class="w-25 mb-4 float-right"
          item-text="label"
          item-value="language"
        />
        <div
          v-else
          class="float-right small"
        >
          Sprache kann erst geändert werden sobal alle Kriterien geladen sind
        </div>
      </div>
      <table
        :key="selectedLanguage"
        class="table comparisonTable"
      >
        <thead>
          <tr>
            <td>
              <button
                v-b-tooltip.hover
                class="switchSymbol"
                placement="bottom"
                title="Verträge vertauschen"
                type="button"
                @click="switchContracts()"
              >
                <i class="fas fa-exchange-alt" />
              </button>
            </td>
            <td>
              <router-link
                :to="
                  '/contract-overview/' +
                    ContractOne.ContractInfo.contractNumber +
                    '/' +
                    ContractOne.VersionInfo.number
                "
              >
                {{
                  getContentByLanguage(
                    ContractOne.VersionInfo.versionContents,
                    "nameShort",
                    selectedLanguage,
                    true,
                  )
                }}
              </router-link>
            </td>

            <td>
              <router-link
                :to="
                  '/contract-overview/' +
                    ContractTwo.ContractInfo.contractNumber +
                    '/' +
                    ContractTwo.VersionInfo.number
                "
              >
                {{
                  getContentByLanguage(
                    ContractTwo.VersionInfo.versionContents,
                    "nameShort",
                    selectedLanguage,
                    true,
                  )
                }}
              </router-link>
            </td>
            <td>Vergleich</td>
          </tr>
        </thead>
        <tbody>
          <ComparableTableRow
            :order="1"
            :text1="
              getContentByLanguage(
                ContractOne.VersionInfo.versionContents,
                'value',
                selectedLanguage,
                false,
              )
            "
            :text2="
              getContentByLanguage(
                ContractTwo.VersionInfo.versionContents,
                'value',
                selectedLanguage,
                false,
              )
            "
            title="Name"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="2"
            :text1="
              getContentByLanguage(
                ContractOne.VersionInfo.versionContents,
                'nameShort',
                selectedLanguage,
                false,
              )
            "
            :text2="
              getContentByLanguage(
                ContractTwo.VersionInfo.versionContents,
                'nameShort',
                selectedLanguage,
                false,
              )
            "
            title="Kurzname"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="3"
            :text1="ContractOne.ContractInfo.contractNumber"
            :text2="ContractTwo.ContractInfo.contractNumber"
            title="Vertragsnummer"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="4"
            :text1="ContractOne.VersionInfo.number.toString()"
            :text2="ContractTwo.VersionInfo.number.toString()"
            title="Version"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <template
            v-if="
              (ContractOne.VersionInfo.ave &&
                (ContractOne.VersionInfo.ave.aveStart ||
                ContractOne.VersionInfo.ave.aveEnd ||
                ContractOne.VersionInfo.ave.ablaufdatum)) ||
                (ContractTwo.VersionInfo.ave &&
                (ContractTwo.VersionInfo.ave.aveStart ||
                ContractTwo.VersionInfo.ave.aveEnd ||
                ContractTwo.VersionInfo.ave.ablaufdatum))
            "
          >
            <ComparableTableRow
              :text1="
                ContractOne.VersionInfo.ave &&
                  (ContractOne.VersionInfo.ave.aveStart ||
                  ContractOne.VersionInfo.ave.aveEnd ||
                  ContractOne.VersionInfo.ave.ablaufdatum)
                  ? 'Ja'
                  : 'Nein'
              "
              :text2="
                ContractTwo.VersionInfo.ave &&
                  (ContractTwo.VersionInfo.ave.aveStart ||
                  ContractTwo.VersionInfo.ave.aveEnd ||
                  ContractTwo.VersionInfo.ave.ablaufdatum)
                  ? 'Ja'
                  : 'Nein'
              "
              title="AVE"
            />

            <ComparableTableRow
              v-if="aveStatus.length != 0"
              :order="12"
              :text1="aveStatus[ContractOne.VersionInfo.ave.aveState]"
              :text2="aveStatus[ContractTwo.VersionInfo.ave.aveState]"
              title="AVE-Status"
              @comparisonFinished="
                (comparison) => {
                  addComparison(comparison);
                }
              "
            />
            <ComparableTableRow
              :order="15"
              :text1="
                ContractOne.VersionInfo.ave &&
                  ContractOne.VersionInfo.ave.aveStart
                  ? formatDate(ContractOne.VersionInfo.ave.aveStart)
                  : ''
              "
              :text2="
                ContractTwo.VersionInfo.ave &&
                  ContractTwo.VersionInfo.ave.aveStart
                  ? formatDate(ContractTwo.VersionInfo.ave.aveStart)
                  : ''
              "
              title="AVE Änderungen gültig ab"
              @comparisonFinished="
                (comparison) => {
                  addComparison(comparison);
                }
              "
            />
            <ComparableTableRow
              :order="16"
              :text1="
                ContractOne.VersionInfo.ave &&
                  ContractOne.VersionInfo.ave.aveEnd
                  ? formatDate(ContractOne.VersionInfo.ave.aveEnd)
                  : ''
              "
              :text2="
                ContractTwo.VersionInfo.ave &&
                  ContractTwo.VersionInfo.ave.aveEnd
                  ? formatDate(ContractTwo.VersionInfo.ave.aveEnd)
                  : ''
              "
              title="AVE Änderungen gültig bis"
              @comparisonFinished="
                (comparison) => {
                  addComparison(comparison);
                }
              "
            />
            <ComparableTableRow
              :order="17"
              :text1="
                ContractOne.VersionInfo.ave &&
                  ContractOne.VersionInfo.ave.ablaufdatum
                  ? formatDate(ContractOne.VersionInfo.ave.ablaufdatum)
                  : ''
              "
              :text2="
                ContractTwo.VersionInfo.ave &&
                  ContractTwo.VersionInfo.ave.ablaufdatum
                  ? formatDate(ContractTwo.VersionInfo.ave.ablaufdatum)
                  : ''
              "
              title="Künstliche Verlängerung bis"
              @comparisonFinished="
                (comparison) => {
                  addComparison(comparison);
                }
              "
            />
          </template>
          <template v-else>
            <ComparableTableRow
              :order="18"
              text1="Nein"
              text2="Nein"
              title="AVE"
              @comparisonFinished="
                (comparison) => {
                  addComparison(comparison);
                }
              "
            />
          </template>
          <ComparableTableRow
            :order="19"
            :text1="ContractOne.VersionInfo.anhang1 ? 'Ja' : 'Nein'"
            :text2="ContractTwo.VersionInfo.anhang1 ? 'Ja' : 'Nein'"
            title="Anhang 1"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            v-if="
              ContractOne.VersionInfo.anhang1 || ContractTwo.VersionInfo.anhang1
            "
            :order="19"
            :text1="
              ContractOne.VersionInfo.anhang1ExtendedUntil
                ? formatDate(ContractOne.VersionInfo.anhang1ExtendedUntil)
                : ''
            "
            :text2="
              ContractTwo.VersionInfo.anhang1ExtendedUntil
                ? formatDate(ContractTwo.VersionInfo.anhang1ExtendedUntil)
                : ''
            "
            title="Anhang 1 bis"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="5"
            :text1="ContractOne.EditionInfo.id.toString()"
            :text2="ContractTwo.EditionInfo.id.toString()"
            title="Edition"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="6"
            :text1="ContractOne.ContractInfo.contractLanguage"
            :text2="ContractTwo.ContractInfo.contractLanguage"
            title="Originalsprache"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            v-if="contractTypes.length != 0"
            :order="7"
            :text1="
              getContractTypeName(ContractOne.ContractInfo.contractTypeId)
            "
            :text2="
              getContractTypeName(ContractTwo.ContractInfo.contractTypeId)
            "
            title="Vertragstyp"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="8"
            :text1="ContractOne.ContractInfo.contractResponsible"
            :text2="ContractTwo.ContractInfo.contractResponsible"
            title="Verantwortlicher"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            v-if="
              getContractValue(
                ContractOne,
                'ContractInfo.companiesUnderContract',
              ) ||
                getContractValue(
                  ContractTwo,
                  'ContractInfo.companiesUnderContract',
                )
            "
            :order="9"
            :text1="
              CreateTextForYearValue(
                getContractValue(
                  ContractOne,
                  'ContractInfo.companiesUnderContract',
                ),
              )
            "
            :text2="
              CreateTextForYearValue(
                getContractValue(
                  ContractTwo,
                  'ContractInfo.companiesUnderContract',
                ),
              )
            "
            title="Anzahl unterstellter Betriebe"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            v-if="
              ContractOne.ContractInfo.employeesUnderContract ||
                ContractTwo.ContractInfo.employeesUnderContract
            "
            :order="10"
            :text1="
              CreateTextForYearValue(
                ContractOne.ContractInfo.employeesUnderContract,
              )
            "
            :text2="
              CreateTextForYearValue(
                ContractTwo.ContractInfo.employeesUnderContract,
              )
            "
            title="Anzahl unterstellter ArbeitnehmerInnen"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />

          <ComparableTableRow
            :order="13"
            :text1="formatDate(ContractOne.VersionInfo.validFrom)"
            :text2="formatDate(ContractTwo.VersionInfo.validFrom)"
            title="Änderung gültig ab"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="14"
            :text1="formatDate(ContractOne.VersionInfo.validTo)"
            :text2="formatDate(ContractTwo.VersionInfo.validTo)"
            title="Änderung gültig bis"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="20"
            :text1="
              ContractOne.EditionInfo.vertragsdatenVisible ? 'Ja' : 'Nein'
            "
            :text2="
              ContractTwo.EditionInfo.vertragsdatenVisible ? 'Ja' : 'Nein'
            "
            title="GAV-Details anzeigen"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="21"
            :text1="ContractOne.EditionInfo.lohnrechnerVisible ? 'Ja' : 'Nein'"
            :text2="ContractTwo.EditionInfo.lohnrechnerVisible ? 'Ja' : 'Nein'"
            title="Lohnrechner anzeigen"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="22"
            :text1="ContractOne.EditionInfo.uelVisible ? 'Ja' : 'Nein'"
            :text2="ContractTwo.EditionInfo.uelVisible ? 'Ja' : 'Nein'"
            title="Üblicher Lohn anzeigen"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="23"
            :text1="ContractOne.EditionInfo.komentar"
            :text2="ContractTwo.EditionInfo.komentar"
            title="Kommentar zur Edition"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="24"
            :text1="
              CreateTextForNogaBranches(
                ContractOne.nogaBranches,
                ContractTwo.nogaBranches,
              )
            "
            :text2="
              CreateTextForNogaBranches(
                ContractTwo.nogaBranches,
                ContractOne.nogaBranches,
              )
            "
            class="newSection"
            title="Noga-Branchen"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />
          <ComparableTableRow
            :order="25"
            :text1="ContractOne.cantons"
            :text2="ContractTwo.cantons"
            class="newSection"
            title="Kantone"
            @comparisonFinished="
              (comparison) => {
                addComparison(comparison);
              }
            "
          />

          <template v-for="(tenant, index) in tenants">
            <template
              v-if="
                hasPublicationData(ContractOne.PublicationInfo, tenant.id) ||
                  hasPublicationData(ContractTwo.PublicationInfo, tenant.id)
              "
            >
              <tr
                :key="index + '_' + tenant.id + '_section'"
                class="newSection"
              >
                <td
                  class="text-center"
                  colspan="4"
                >
                  {{ tenant.bezeichnung || "" }}
                </td>
              </tr>
              <ComparableTableRow
                :key="index + '_' + tenant.id + '_publicationDate'"
                :order="26 + index * 7"
                :tenant="tenant.id"
                :text1="
                  formatDate(
                    getPublicationProperty(
                      ContractOne.PublicationInfo,
                      tenant.id,
                      'publicationDate',
                    ),
                  ) || ''
                "
                :text2="
                  formatDate(
                    getPublicationProperty(
                      ContractTwo.PublicationInfo,
                      tenant.id,
                      'publicationDate',
                    ),
                  ) || ''
                "
                title="Publikationsdatum"
                @comparisonFinished="
                  (comparison) => {
                    addComparison(comparison);
                  }
                "
              />
              <ComparableTableRow
                :key="index + '_' + tenant.id + '_validFrom'"
                :order="27 + index * 7"
                :tenant="tenant.id"
                :text1="
                  formatDate(
                    getPublicationProperty(
                      ContractOne.PublicationInfo,
                      tenant.id,
                      'validFrom',
                    ),
                  )
                "
                :text2="
                  formatDate(
                    getPublicationProperty(
                      ContractTwo.PublicationInfo,
                      tenant.id,
                      'validFrom',
                    ),
                  )
                "
                title="Gültig ab"
                @comparisonFinished="
                  (comparison) => {
                    addComparison(comparison);
                  }
                "
              />
              <ComparableTableRow
                :key="index + '_' + tenant.id + '_validTo'"
                :order="28 + index * 7"
                :tenant="tenant.id"
                :text1="
                  getPublicationContentProperty(
                    ContractOne.PublicationInfo,
                    tenant.id,
                    'value',
                    selectedLanguage,
                  )
                "
                :text2="
                  getPublicationContentProperty(
                    ContractTwo.PublicationInfo,
                    tenant.id,
                    'value',
                    selectedLanguage,
                  )
                "
                title="Anzeigename"
                @comparisonFinished="
                  (comparison) => {
                    addComparison(comparison);
                  }
                "
              />
              <ComparableTableRow
                :key="index + '_' + tenant.id + '_shortName'"
                :order="29 + index * 7"
                :tenant="tenant.id"
                :text1="
                  getPublicationContentProperty(
                    ContractOne.PublicationInfo,
                    tenant.id,
                    'shortName',
                    selectedLanguage,
                  )
                "
                :text2="
                  getPublicationContentProperty(
                    ContractTwo.PublicationInfo,
                    tenant.id,
                    'shortName',
                    selectedLanguage,
                  )
                "
                title="Kurzname Tenant"
                @comparisonFinished="
                  (comparison) => {
                    addComparison(comparison);
                  }
                "
              />
              <ComparableTableRow
                :key="index + '_' + tenant.id + '_comment'"
                :order="30 + index * 7"
                :tenant="tenant.id"
                :text1="
                  getPublicationContentProperty(
                    ContractOne.PublicationInfo,
                    tenant.id,
                    'comment',
                    selectedLanguage,
                  )
                "
                :text2="
                  getPublicationContentProperty(
                    ContractTwo.PublicationInfo,
                    tenant.id,
                    'comment',
                    selectedLanguage,
                  )
                "
                title="Kommentar"
                @comparisonFinished="
                  (comparison) => {
                    addComparison(comparison);
                  }
                "
              />
              <ComparableTableRow
                :key="index + '_' + tenant.id + '_news'"
                :order="31 + index * 7"
                :tenant="tenant.id"
                :text1="
                  getPublicationContentProperty(
                    ContractOne.PublicationInfo,
                    tenant.id,
                    'news',
                    selectedLanguage,
                  )
                "
                :text2="
                  getPublicationContentProperty(
                    ContractTwo.PublicationInfo,
                    tenant.id,
                    'news',
                    selectedLanguage,
                  )
                "
                title="Was ist neu"
                @comparisonFinished="
                  (comparison) => {
                    addComparison(comparison);
                  }
                "
              />
              <ComparableTableRow
                :key="index + '_' + tenant.id + '_rssFeed'"
                :order="32 + index * 7"
                :tenant="tenant.id"
                :text1="
                  getPublicationContentProperty(
                    ContractOne.PublicationInfo,
                    tenant.id,
                    'rssFeed',
                    selectedLanguage,
                  )
                "
                :text2="
                  getPublicationContentProperty(
                    ContractTwo.PublicationInfo,
                    tenant.id,
                    'rssFeed',
                    selectedLanguage,
                  )
                "
                title="RSS-Feed"
                @comparisonFinished="
                  (comparison) => {
                    addComparison(comparison);
                  }
                "
              />
            </template>
          </template>
        </tbody>
      </table>
      <button
        v-if="storedPdf"
        class="d-block"
        @click="
          storedPdf.download(
            `${ContractOne.EditionInfo.id.toString()}_${ContractTwo.EditionInfo.id.toString()}_${$moment(
              new Date(),
            ).format('YYYYMMDD')}.pdf`,
          )
        "
      >
        <i class="fas fa-file-pdf" /> Vergleich als PDF speichern
      </button>
      <button
        v-if="storedPdf"
        class="d-block"
        @click="
          downloadCsv(
            `${ContractOne.EditionInfo.id.toString()}_${ContractTwo.EditionInfo.id.toString()}_${$moment(
              new Date(),
            ).format('YYYYMMDD')}.csv`,
          )
        "
      >
        <i class="fas fa-file-csv" /> Vergleich als CSV speichern
      </button>
      <div
        class="w-100"
        style="height: 30px"
      >
        <v-select
          v-if="storedPdf"
          v-model="selectedLanguage"
          :items="languages"
          class="w-25 mb-4 float-right"
          item-text="label"
          item-value="language"
        />
      </div>
      <CompareCriterions
        v-if="allContractInfosLoaded"
        :contract-one-information="{
          contractId: ContractOne.ContractInfo.contractNumber, // Make sure this is populated
          versionId: ContractOne.VersionInfo.number.toString(),
          editionId: ContractOne.EditionInfo.id,
        }"
        :contract-one-short-name="
          getContentByLanguage(
            ContractOne.VersionInfo.versionContents,
            'nameShort',
            selectedLanguage,
            true,
          )
        "
        :contract-two-information="{
          contractId: ContractTwo.ContractInfo.contractNumber,
          versionId: ContractTwo.VersionInfo.number.toString(),
          editionId: ContractTwo.EditionInfo.id,
        }"
        :contract-two-short-name="
          getContentByLanguage(
            ContractTwo.VersionInfo.versionContents,
            'nameShort',
            selectedLanguage,
            true,
          )
        "
        :selected-language="selectedLanguage"
        @criterionsLoaded="criterionsLoaded"
      />
      <button
        v-if="storedPdf"
        class="d-block"
        @click="
          storedPdf.download(
            `${ContractOne.EditionInfo.id.toString()}_${ContractTwo.EditionInfo.id.toString()}_${$moment(
              new Date(),
            ).format('YYYYMMDD')}.pdf`,
          )
        "
      >
        <i class="fas fa-file-pdf" /> Vergleich als PDF speichern
      </button>
      <button
        v-if="storedPdf"
        class="d-block"
        @click="
          downloadCsv(
            `${ContractOne.EditionInfo.id.toString()}_${ContractTwo.EditionInfo.id.toString()}_${$moment(
              new Date(),
            ).format('YYYYMMDD')}.csv`,
          )
        "
      >
        <i class="fas fa-file-csv" /> Vergleich als CSV speichern
      </button>
    </div>
  </div>
</template>

<script>
import { GetSinlgeEdition } from "@/services/contract.edition.service.js";
import {
  GetVersionInformation,
  GetContractInformation,
} from "@/services/contract.service.js";
import { GetAllPublications } from "@/services/contract.tenants.service.js";
import { GetCantons } from "@/services/contract.edition.cantons.service.js";
import { GetNogaBranchesForEdition } from "@/services/contract.edition.nogaBranches.service.js";
import ComparableTableRow from "@/components/compare/ComparableTableRow.vue";
import CompareCriterions from "@/components/compare/CompareCriterions.vue";

var htmlToPdfmake = require("html-to-pdfmake");
import { StammdatenMixin } from "@/mixins/StammdatenMixin";

export default {
  components: {
    ComparableTableRow,
    CompareCriterions,
  },
  mixins: [StammdatenMixin],
  props: {
    contractInformations: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ContractOne: {
        EditionInfo: {},
        VersionInfo: {},
        ContractInfo: {},
        cantons: "",
        nogaBranches: [],
        PublicationInfo: [],
      },
      ContractTwo: {
        EditionInfo: {},
        VersionInfo: {},
        ContractInfo: {},
        cantons: "",
        nogaBranches: [],
        PublicationInfo: [],
      },
      isLoading: false,
      errorObject: null,
      noContractsSelected: false,
      selectedLanguage: "de-CH",
      languages: [
        { language: "de-CH", label: "Deutsch" },
        { language: "fr-CH", label: "Französisch" },
        { language: "it-CH", label: "Italienisch" },
      ],
      contractTypes: [],
      tenants: [],
      aveStatus: [],
      allNogaBranches: [],
      comparison: [],
      criterionComparisonsLoaded: false,
      criterionComparisons: [],
      storedPdf: null,
      pdfPrepareTimeout: null,
      loadingCount: 0,
      processedContracts: new Set(),
      allContractInfosLoaded: false,
      contractOneNumeber: "",
      contractTwoNumber: "",
    };
  },
  computed: {
    isContractsReadyForComparison() {
      return (
        this.ContractOne?.ContractInfo?.contractNumber &&
        this.ContractTwo?.ContractInfo?.contractNumber &&
        this.ContractOne?.VersionInfo?.number &&
        this.ContractTwo?.VersionInfo?.number &&
        this.ContractOne?.EditionInfo?.id &&
        this.ContractTwo?.EditionInfo?.id
      );
    },
  },
  watch: {
    selectedLanguage() {
      this.storedPdf = null;
      // Clear existing timeout if any
      if (this.pdfPrepareTimeout) {
        clearTimeout(this.pdfPrepareTimeout);
      }
      // Set new timeout
      this.pdfPrepareTimeout = setTimeout(() => {
        this.preparePdf();
      }, 500);
    },

    contractInformations: {
      handler(newVal) {
        if (newVal && newVal.length) {
          this.loadContractInformation();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.errorObject = null;
    if (!this.contractInformations || this.contractInformations.length < 2) {
      this.noContractsSelected = true;
      return;
    }

    Promise.all([
      this.loadNogaBranches(),
      this.loadContractTypes(),
      this.loadTenants(),
      this.loadAveStatus(),
    ]).then(() => {
      this.loadContractInformation();
    });
  },

  beforeDestroy() {
    // Clear timeout when component is destroyed
    if (this.pdfPrepareTimeout) {
      clearTimeout(this.pdfPrepareTimeout);
    }
  },
  methods: {
    getContractTypeName(contractTypeId) {
      if (!contractTypeId || !this.contractTypes) return "";

      const contractType = this.contractTypes.find(
        (type) => type.id === contractTypeId,
      );
      return contractType ? contractType.name : "";
    },
    criterionsLoaded(loadedCriterions) {
      this.criterionComparisons = loadedCriterions;
      this.criterionComparisonsLoaded = true;

      if (this.pdfPrepareTimeout) {
        clearTimeout(this.pdfPrepareTimeout);
      }
      this.pdfPrepareTimeout = setTimeout(() => {
        this.preparePdf();
      }, 200);
    },
    downloadCsv(filename) {
      let csvContent = "";
      csvContent += `;${this.getContentByLanguage(
        this.ContractOne.VersionInfo.versionContents,
        "nameShort",
        this.selectedLanguage,
        true,
      )};${this.getContentByLanguage(
        this.ContractTwo.VersionInfo.versionContents,
        "nameShort",
        this.selectedLanguage,
        true,
      )};Vergleich\n`;

      this.comparison = this.comparison.sort((a, b) => {
        return a.order - b.order;
      });

      var tenants = [];
      this.comparison.map((comparison) => {
        if (comparison.tenant && tenants.indexOf(comparison.tenant) == -1) {
          var tenant = this.tenants.filter((tenant) => {
            return tenant.id == comparison.tenant;
          });

          if (tenant[0]) {
            csvContent += `${tenant[0].bezeichnung};;;\n`;
            tenants.push(comparison.tenant);
          }
        }

        csvContent += `"${comparison.title.replace(
          /"/g,
          '""',
        )}";"${comparison.textOneInnerText.replace(
          /"/g,
          '""',
        )}";"${comparison.textTwoInnerText.replace(
          /"/g,
          '""',
        )}";"${comparison.diffText.replace(/"/g, '""')}"\n`;
      });

      // add Criterions
      this.criterionComparisons.map((comparison) => {
        csvContent += `"${comparison.title.replace(
          /"/g,
          '""',
        )}";"${comparison.textOneInnerText.replace(
          /"/g,
          '""',
        )}";"${comparison.textTwoInnerText.replace(
          /"/g,
          '""',
        )}";"${comparison.diffText.replace(/"/g, '""')}"\n`;
      });

      var universalBOM = "\uFEFF";
      var blob = new Blob([universalBOM, csvContent], { type: "text/csv" });

      if (navigator.msSaveOrOpenBlob) {
        navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        var csvUrl = URL.createObjectURL(blob);

        const link = document.createElement("a");
        link.setAttribute("href", csvUrl);
        link.setAttribute("download", filename);
        link.click();
      }
    },
    preparePdf() {
      var pdfContent = {
        pageOrientation: "landscape",
        content: [
          {
            // Image endocded in base64
            image:
              "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAMCAgMCAgMDAwMEAwMEBQgFBQQEBQoHBwYIDAoMDAsKCwsNDhIQDQ4" +
              "RDgsLEBYQERMUFRUVDA8XGBYUGBIUFRT/2wBDAQMEBAUEBQkFBQkUDQsNFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQUFBQU" +
              "FBQUFBT/wAARCAA3ALwDASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhM" +
              "UEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJip" +
              "KTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAE" +
              "CAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5" +
              "OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4" +
              "uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD6XvvEWt/FrxdqjTa+dC0zT/J+5bR3EjySxLMERJcxoiI6AttLM245AwKsf8IFJ/0P9/8A+CfTf/" +
              "jFeRS+KpNE8Z+JLdGOXexbaPewtxX0HZ/DfTNB0fR5/GXih9H1DVmVLe1jAwHYDCkkHJGRnoBmvhIV6terOMdeV6tuy3sup+646P8AZsaUYtRjKMeWKhG" +
              "Tfupv7Lfm+xzP/CBSf9D/AH//AIJ9N/8AjFH/AAgUn/Q/3/8A4J9N/wDjFZPj7RdU8E+O7Lw5HeLqBv2QWkydX3NtwwHQg9a734ifC2DwHpen6kdZup7F" +
              "r2K2vXZVHko527x9Djr604zry5/dfub6v/M454pw9jeqv3vw/u4a/wDkny9TmP8AhApP+h/v/wDwT6b/APGKP+ECk/6H+/8A/BPpv/xirXxG8C3ng3xp4" +
              "Z0WwvZ72HW3EUc0qgFW3AN07BSD+dcn8XL+2+HfjKfQrLUJr77PEhmkmAyHYZ28exH51nWrVKCk6kbcrSer3evfsbYWpUxjgqFRPnTkv3cNk7O/u6a6HR" +
              "f8IFJ/0P8Af/8Agn03/wCMUf8ACBSf9D/f/wDgn03/AOMV0en/AA70zSPCel6z4v8AEk+lnUghiW3jyke5dyhmwe3UnArznxg02i+MhoWgapH4qaUZibT" +
              "v3r57qwXIBHtVValWjFSmt7ac2uu2l7kYevPFVJU6VRO19fZxS0315LaHR/8ACBSf9D/f/wDgn03/AOMUf8IFJ/0P9/8A+CfTf/jFcZ4ibxX4SWBtZ0e9" +
              "05J2CRvNEQrMe2Rxn2q3JpfjiJpFk8PajGyBC2+Ej77bV/M8Vz/XKl2uSV1/iO32dblUvbQs9vdp6/8Akp1H/CBSf9D/AH//AIJ9N/8AjFH/AAgUn/Q/3" +
              "/8A4J9N/wDjFcXI/iuHXo9EfRr5dXkj85LIxHzGTn5gPTg/lXYeOtPtvCvw70TWopNS/tS8ljimhuIiIgzIxYKdvJyuOCauOJnKMpcrSjvdsyqe2pzp0/" +
              "aRbntaFN/P4dtNyT/hApP+h/v/APwT6b/8Yo/4QKT/AKH+/wD/AAT6b/8AGK5DVbfxjoWkDVdQ0LULPT8Am4lgYKoPQt3H40uh23jHxLpp1DS9C1C9su0" +
              "0UJ2tj+7/AHvwqPrlTm5eSV/+3jX2dbk9p7aHLe1+Wna/a/Ludd/wgUn/AEP9/wD+CfTf/jFH/CBSf9D/AH//AIJ9N/8AjFeXXHj66tZpIZt8M0bbXjkU" +
              "qykdQQehrodFh8YeItLbUtM0PUL6xGf38MJKnHXH978KiOPc3yxi2/Vm1TC4qjHnqVIpd3Gmv/bTsP8AhApP+h/v/wDwT6b/APGKP+EBk/6H+/8A/BPpv" +
              "/xirfw+8Ht42+Gur+IftV6NRs3mjjs4UB3uighSCM5JOMV534mvPEvgtoF1zTbvTDOCYvtCYD464Pr7VvUxFSnTjVlF8rV73f8ASOKi6uIrTw8KseeLs1" +
              "yU738vd1+R3P8Awgcn/Q/3/wD4J9N/+MVfT4T37cv48voowu4yNpGm4Uds4g689KX4N69p+ueE7x9RtobrN4UBlUbgAi9D17+tdzd+H9F1aaSaOe4spZD" +
              "kmOTcuf8AdOf5172Cw/1mlGtJ6PzZ8lmmd4nA154WNuaLs7wh26e6cBefDG5sVjd/iBeFJMhWXSdN5x148j3FVf8AhAZP+h/v/wDwT6b/APGK72bwVfKo" +
              "Ntd2OpRrnal1HgjOM4PIBOB3HQVgap4RmiDG40i8s/WawkMiD3wcj+VVXwNaLvR1Xm3cxwvEjkksS0n3VODX/pNzk9c8N6p4c0q61XTPFx1e7so2nWw1D" +
              "TbSGO4CjJTzIESSNiAQHVuDXuXw4+KdrqHhOxuL+eabzoop7eaQZkeCWJJY957sBJtJ77c96+bviRJH4Z8K3d+utrNFLm1jgmj2SO7I5CjBIJwjH6A13H" +
              "w3Y/8ACvvC3P8AzBtP/wDSOGuXCVa1KvKnUVmktNz38ZRoZpl8azkprmsmko9FdaJfl19LfJ3xG8Ujw58YNTkZS6RnTpimeoFnbnH6V92+LdK/4W5N4A8" +
              "Y+G7HSvFuiRRTLPZ3twI4wkwj/e52tl4yh+XGee1fmp+05Dd2Hxev3kV4FuLKxkT0YC1iQkfRkYfVTXn2m+NPEGi2c1pp+uajYWs3+shtbp40f6qpANfN" +
              "U8T9VrV4TXNGTv6NO63TP2vFcIPPMHgsXhqyhUhBLVNpqUFFrRppro0z9YNQ+HeiN8fPCd/pNlZ2mkabpVxqVxLaqBG7hwkZJHBwST/wGn+H/Engv47+B" +
              "viB4f8ACniObxBNdNLcSefE8f2eSTJjCblXKBkGCM9Otfk5b+NvENrCIYNd1KGIJ5Qjju5FXZ/dwD05PHvUGmeJtX0VnbTtUvNPZwA7Ws7xFgOgO0jNdS" +
              "zWMZNRpLllfmXqktO33M8mXhlXnTTnjW6kFFQfLppJyvJNtvfSzVvM/Xr4SeINM+JXwq8I+MNX4vvDiTfaGbrFNFG8Uu78Bu/Kvk6z+N3wo8SWXiDU/GO" +
              "kare+Kb+8up4rm2ZvKRG/1I4cfdGO3bvXx3D4x163tp7aHWtQit5yzSwx3Tqkhb7xYA4Oe+etZv2yf/nq351yYnMJ1oU4qKulrdXu7JX9bI9fL/Dulg6t" +
              "ec8RK03ePLeLhG7ly3vqm3+B+u/wvuviBY+A/Cv2Kfw/8RdDuIo0a6jmNrJBDgBfmIYSEDIIIByMVtaPdfD3RPj5e6bp0lhaeLLrSlaW3hKqDiQ5AA4Eh" +
              "GCR1IANfkJpPjrxJ4ft3g0vX9T02CTl47S8kiVvqFIBrPXWr9bwXa3s63YfzPtAkIk3f3t3XPvXbHN+SMEqd+W27va3bS+vm2eJU8LqlapWlLFqKmpL3Y" +
              "ct7u65lzcrt2ilc/Vj4hanceGfgv4gg13Q7rTbWa9IgfXNZjuZ2maVSjRYByM8hc5Az0Fcn+2/8Xtd8A3HhfSNMvfslnfQG5nVUG6Ro5EKfNjIAIB4r84" +
              "dY8beIfEDQtqmualqRh/1RvLuSXZ/u7icfhVfUvE2r608b6hql5fvGNqNdTtKVHoNxOBXNiMylUpTp0043SSd9dG29kt72PSy/wAOFh8TRxGIqxnyOcnH" +
              "ldm5JJW5pS2te/5WP1f8ZfE3QovgzD8aYXUarJoJsrXnpNKwG36q4b8AarHxHpWn/Cf4Gahr0yJYzalYhppz8gka1m2MxPbdjk1+VDeI9VfTV09tSu2sF" +
              "betqZm8oN6hM4z+FPuvFGs31jFZXGq3txZxYMdtLcO0aYGBtUnA4J6Vo82nKTk49F9902/nZHPHwxjGCprE6Kcne2qg4tRitfs3bv8Agfqr8UrT4lafrn" +
              "j3Vl17SdL8AmyidTq486N4xERKkag/IxOeSOSVxmuxa6i1zRfh7qfhDTr3W9JjVWhbS9TS1t4E2KB56n764yNuCQQeM1+P99428Q6np8dhea7qV3Yx42W" +
              "s93I8S46YUnAp2l+OvEeh2slrpuv6np9tJ9+G1u5Ikb6hSAa1jmyjOT5XaXd3ad76XVkvkc0/DGvOhTi8RBShppBpNcvL71pKTl1vfurWZ97fF34d6p8Y" +
              "PiL471bQJtL09fD9tE2pw/aTLvl8pmO1lXG7amDnvXtWsf8ACWeLvD3w01D4TanZ22hLCTcyyODbonlAL5iA5fBDDA5Dda/Jez8UazpsdxHaate2qXH+u" +
              "WG4dBL1+8Afm6nr61Np/jbxDpNjLZWOu6lZWcufMt7e7kjjfPXKggGuWljoU5Tk4O89W07Pe6tpp2fc9LE+H+JrU6NOOJi1SVoqULqzhyy5lzau+sddNt" +
              "T9TvBHiXU9O+CnxW1VtWs7zWLC81B21HSU2QmZIVJaMdsEfmDXEftk+IpY/gh8OtQnlaSe6eF3lbkszW24n6k1+cdr4s1uxsZbK31e+t7OXPmW8Vw6xvn" +
              "g5UHBz70X3ivWtStobe81a9u7eH/Vwzzs6Jxj5VJwOPSnVzJ1MPKhy7q2/ne4sL4cvDZhDGuunyzcrcttOXltvprr2PsX4PeOvsfgMuZCN+pyr1x0ij/x" +
              "r0zT/iN9397jPvXxd4H8Y2tr4Hi059atLDUItRmn8q+do1kR44wCJNpUco33iO1dlZ+I9ctbcXItZLq2/wCfmzZbiL/vuMsK+xyecfqVOCd2l+p/PvHOA" +
              "rYPPsTzwai2rOzs1ZbPqfY2n/EQHBMn611ej+PvOuIlEn3jjrXxJpfxV+YAy4I6+td94N+JiXGuafH5v3plB5969u58AcJ8cvHX2mPQ7EPuUR3d+w9z+5" +
              "jP5Cavqn4a/wDJPPCv/YF07/0jhr86Pirq091481C2EjbNPji08DOfmjXMn/kR5K/Sz4Y+F9Um8CaDAlnIZbPTLG2nXHKSLZwblPuM18fRnKtmFeS1Wi+" +
              "4/fsTl0Mp4Yy91HaVTmm/nZr8GjU+JHwt+E/xK8df8I/f6r4en8UjdMNDvGjmmTd8zFI1kSVc/eKhsHJOMnNczqX7HHww0a/sLXUYvDFjc6lKYLK3ltJk" +
              "e4kAyUjDXeWOOcDmvO/E/wCyj8WH/aJ1/wAV+Dn07wtY6nqFxfSapLfJeQuXt2jWVIHi82K43EfMr7QOlYl1+x78VfEvhHwpYajafZLzSr+W5uJJPFU91" +
              "JLL9geI3UbnBh8ycq2xW6ZzjpX0U8Hh5ycpU02fk2H4lzjC01RoYmUYrome4/8ADC3gL/oE6L/4L5//AJJqhrv7Gfwx8L6Pd6tq9v4d0zTLOMy3F5dWc0" +
              "cUSDqzMbrAHvXj99+yd+0Stv4dfTPHclpLFpOnnUIpdUd86gqm1uiD3TyGMgI6v74NM1b9kT46TP8AEGwXxJPqNvqFhqNnZ3dxrI8m9ikCLaRPCyko0YX" +
              "rkAEcFs1H1HDf8+0dH+tme/8AQZP7z221/Yg+Hl9aw3NvpuhT28yLJHLHYzlXUjIYH7VyCDUv/DCvgL/oE6L/AOC+f/5JrxXUP2YPjjfN4yl08yeHbm8t" +
              "LK108WviiWS3eGJojcoY2zsln2t8wwqAbQPmJrvvgn+zj8TNE+IngnVPGOs6hL4d0e1vpP7PbXGmaKZrgPbRyBAolVF3cHcBkDJAo+o4X/n2g/1tz3/oM" +
              "n95Zk/Zd+C8Pi5PCr33g9PEzp5i6Q0cguiuM58v7Xu6c9K6P/hhXwF/0CdF/wDBfP8A/JNeTax+yj8WrH406jqmiR6FNpVz42PitfEV20El0IZAqm32SR" +
              "M6tEAdpR1GCRySMYmj/sp/tAQ+FfEdnqPijUpb66SASvb6+rJqM63JkacIy/KDGdpVnTcPl4ABo+o4b/n2g/1tz3/oMn957p/wwr4C/wCgTov/AIL5/wD" +
              "5Jo/4YV8Bf9AnRf8AwXz/APyTXjVx+zv+0bf6t4Cnub2xtn0GPTQ91p2uzjKx3Ja4SRZGbcTEQPl4bBBJ4FZH/DHPxxW3guF168GpeXHLIw8TThTcLqZk" +
              "BxuxgWjFcYxk+vNH1HDf8+0H+tue/wDQZP7z27SP2M/hj4gglm0y38OahDDM9vJJbWkzqkqHDoSLrhlPBHam61+xt8L/AA3axXOrQ+G9Nt5Zkt0lurSaN" +
              "Wkc7UQE3XLMeAO5rx/UP2Rfi9ongfUPCfhu0tLe2uPE2q6k+oQ+Ip0lmhlRvsjhSdq7SQGyGbPzdean1v8AY9+LPi7w/qc3iS8fXNaF54eltLe41+QQPH" +
              "bRxG+6cJI7xAB8Z5zkZNH1HDf8+0H+tue/9Bk/vPaf+GFfAX/QJ0X/AMF8/wD8k1z2k/ss/BrXr1LPTrrwnfXck89qkEEMju00GPOjAF1ksmRuHbPNeWz" +
              "/ALK37QzWfhlf+EnuRbWxu2t9PttfKyaK8l6JYi0zq3nhYvlzhjwQBg1f0P8AY3+JOl+OtJ8S3awXt5BrHiKV5oNbe2lhiuwPslwhUFdytuJXb6ZBAxR9" +
              "Rw3/AD7Qf6257/0GT+89k/4YV8Bf9AnRf/BfP/8AJNH/AAwr4C/6BOi/+C+f/wCSa8T8N/sofH208N2UP/CUtpl7Dqv2dnfVZHmk0y4g8q7eTDmPzFIV4" +
              "yoBzkkAmo9T/ZR/aAS68bR2Xiq7kku4byG0vhrhSO7jeWM2q+WVLRtGin5sjGMDduNH1HDf8+0H+tme/wDQZP7z2KH9jP4YXGs3OkRQeHJNVtoknmsltJ" +
              "jNHG5IR2T7VkAlWwT1warL+yH8Km8RNoIh8PHWFTzDZ/YLjeFwGz/x8+hB/GvP/iF+xr46tfF/i698DmVE1nQtJsbbVZPEdwl3bzQXCvchixO7emcHOAQ" +
              "cAbjVPxt8DfjT4H8e674r0Nb2bw7pdvfQWVvp+uT3Fzd2hsDFbgxsWdpRLhjjGCMgE80fUcN/z7Qf62Z7/wBBk/vPXV/Yj+HT3clqthoDXMah3hWymLqp" +
              "zglftWQDg8+1WLX9hvwNY3AuLXTdItbgdJreyuI3/wC+luga+R/hv8Efi1460O7i0Ww13T7uO7trjWp7q+ezXUwLQxRpDLLGr7opAZHViV3SZHIxX098W" +
              "vgh8VfEnwn+GWj22qz69faLaSxa9Zf2y1nJfTtbFIJjcoq7/JlIc8DdjOCaccFhlqqaM6nFGdVouFTFSkn0bujT8RfsXaLfxPNPr8NvbxKXf7Rp/nhVHJ" +
              "O+WVnA/wCBV5p4f/Zc0G78TWl/4J8V6L4oudO8jUXsLG+2LJCx3RlkbzcK+0jIcA84rKk/ZT+PL+JrDUr/AMUSavc28mlxyXX9syJFNCli8V4DDnad0hj" +
              "6jLYJ7msTwv8AsXfGPRdL0WwW4g0+2ig8PWl4LDV2gZobUTC8QMmGwQ64wea64xUdj52pWlWd52+SS/JI+hvBX7F/hfRXsdT1K206XXh/pNzeQ2O6U3LH" +
              "e7hpZHTO4nB2D1GK9+0XRbTw/p0dlZRmOFCWJZizOxOWZmPLMSSST1Jr4J0L9lf9oiyuPBH27xVcyppcEMKtBrm06c6XryO7Flbzg8JUdCTjacDmv0E/W" +
              "op0adNtwja52YvM8Zjoxhiarko6JPolt9wUUUV0HmBRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAFFFFABRRRQAUUUUAf/Z",
            width: 150,
            margin: [600, 0, 0, 0],
          },
          {
            text: "Editionsvergleich",
            fontSize: 18,
            margin: [0, 0, 0, 20],
          },
          {
            style: "comparisonTable",
            fontSize: 10,
            table: {
              widths: [100, 200, 200, 200],
              body: [
                [
                  "",
                  {
                    text: this.getContentByLanguage(
                      this.ContractOne.VersionInfo.versionContents,
                      "nameShort",
                      this.selectedLanguage,
                      true,
                    ),
                    bold: true,
                  },
                  {
                    text: this.getContentByLanguage(
                      this.ContractTwo.VersionInfo.versionContents,
                      "nameShort",
                      this.selectedLanguage,
                      true,
                    ),
                    bold: true,
                  },
                  {
                    text: "Vergleich",
                    bold: true,
                  },
                ],
              ],
            },
          },
        ],
        styles: {
          nonave: {
            background: "#a4dfff",
          },
          nonpvl: {
            background: "#ffffa4",
          },
        },
      };

      var tenants = [];

      this.comparison = this.comparison.sort((a, b) => {
        return a.order - b.order;
      });

      this.comparison.map((comparison) => {
        if (comparison.tenant && tenants.indexOf(comparison.tenant) == -1) {
          var tenant = this.tenants.filter((tenant) => {
            return tenant.id == comparison.tenant;
          });

          if (tenant[0]) {
            var newItem = [
              {
                text: tenant[0].bezeichnung,
                colSpan: 4,
                alignment: "center",
                bold: true,
                fontSize: 12,
              },
              { text: "" },
              { text: "" },
              { text: "" },
            ];

            pdfContent.content[2].table.body.push(newItem);
            tenants.push(comparison.tenant);
          }
        }

        var comparisonObject = [
          {
            text: comparison.title,
            bold: true,
          },
          { text: htmlToPdfmake(comparison.textOne) },
          { text: htmlToPdfmake(comparison.textTwo) },
          { text: htmlToPdfmake(comparison.diff.replace(/<br>/g, "\n")) },
        ];

        comparisonObject = JSON.parse(
          JSON.stringify(comparisonObject).replace(/"stack":/g, '"text":'),
        );

        // for some reason, the ff gets replaced by nothing, so we undo that.
        comparisonObject.map((item) => {
          if (typeof item.text == typeof []) {
            item.text.map((element) => {
              if (element.background) {
                element.background = element.background.replace(
                  "#83 83",
                  "#83ff83",
                );
              }
            });
          }
        });

        pdfContent.content[2].table.body.push(comparisonObject);
      });

      pdfContent.content[2].table.body = this.addCriterionsTopdfContentTable(
        pdfContent.content[2].table.body,
      );

      // eslint-disable-next-line
      this.storedPdf = pdfMake.createPdf(pdfContent);
    },
    addCriterionsTopdfContentTable(pdfTableBody) {
      this.criterionComparisons.map((comparison) => {
        var comparisonObject = [
          {
            text: comparison.title,
            bold: true,
          },
          { text: htmlToPdfmake(comparison.textOne) },
          { text: htmlToPdfmake(comparison.textTwo) },
          { text: htmlToPdfmake(comparison.diff.replace(/<br>/g, "\n")) },
        ];

        comparisonObject = JSON.parse(
          JSON.stringify(comparisonObject).replace(/"stack":/g, '"text":'),
        );

        // for some reason, the ff gets replaced by nothing, so we undo that.
        comparisonObject.map((item) => {
          if (typeof item.text == typeof []) {
            item.text.map((element) => {
              if (element.background) {
                element.background = element.background.replace(
                  "#83 83",
                  "#83ff83",
                );
              }
              if (element.margin) {
                delete element.margin;
              }
            });
          }
        });

        pdfTableBody.push(comparisonObject);
      });

      return pdfTableBody;
    },
    addComparison(comparison) {
      var existingComparison = this.comparison.filter((existingcomparison) => {
        return existingcomparison.order == comparison.order;
      });

      if (existingComparison[0]) {
        var index = this.comparison.indexOf(existingComparison[0]);
        this.comparison.splice(index, 1);
      }

      this.comparison.push(comparison);
    },
    formatDate(date) {
      if (!date) {
        return "";
      }

      var newDate = this.$moment(date).format("DD.MM.YYYY");
      return newDate;
    },
    switchContracts() {
      const tempContract = this.ContractOne;
      this.ContractOne = this.ContractTwo;
      this.ContractTwo = tempContract;
      this.storedPdf = null;

      if (this.pdfPrepareTimeout) {
        clearTimeout(this.pdfPrepareTimeout);
      }
      this.pdfPrepareTimeout = setTimeout(() => {
        this.preparePdf();
      }, 500);
    },
    getPublicationProperty(publicationInfo, tenantId, propertyName) {
      if (!publicationInfo || !Array.isArray(publicationInfo)) {
        return "";
      }

      var publication = publicationInfo.filter(function (publication) {
        return publication && publication.tenantId === tenantId;
      });

      if (publication[0] && publication[0][propertyName]) {
        return publication[0][propertyName];
      }

      return "";
    },
    getPublicationContentProperty(
      publicationInfo,
      tenantId,
      propertyName,
      language,
    ) {
      if (!publicationInfo || !Array.isArray(publicationInfo)) {
        return "";
      }

      var publication = publicationInfo.filter(function (publication) {
        return publication && publication.tenantId === tenantId;
      });

      if (publication[0] && publication[0].publicationContents) {
        return this.getContentByLanguage(
          publication[0].publicationContents,
          propertyName,
          language,
          false,
        );
      }

      return "";
    },
    hasPublicationData(publicationInfo, tenantId) {
      if (!publicationInfo || !Array.isArray(publicationInfo)) {
        return false;
      }
      return publicationInfo.some(function (publication) {
        return publication && publication.tenantId === tenantId;
      });
    },
    getContentByLanguage(
      content,
      propertyName,
      language,
      returnDefaultValueIfEmpty,
    ) {
      var contentInLanguage = content.filter((content) => {
        return language == content.language;
      });

      if (contentInLanguage.length == 1) {
        if (contentInLanguage[0][propertyName]) {
          return contentInLanguage[0][propertyName];
        }
      }

      if (returnDefaultValueIfEmpty) {
        if (content[0] && content[0][[propertyName]]) {
          return content[0][[propertyName]];
        }
      }

      return "";
    },
    sortYearsValues(yearValueCollection) {
      // Return empty array if yearValueCollection is null/undefined
      if (!yearValueCollection) {
        return [];
      }

      // Ensure we're working with an array
      if (!Array.isArray(yearValueCollection)) {
        return [];
      }

      return yearValueCollection.sort((a, b) =>
        a.year < b.year ? 1 : a.year > b.year ? -1 : 0,
      );
    },
    getContractValue(contract, path) {
      if (!contract) return null;

      var parts = path.split(".");
      var current = contract;

      for (var i = 0; i < parts.length; i++) {
        if (current == null) return null;
        current = current[parts[i]];
      }

      return current;
    },
    CreateTextForYearValue(yearValueCollection) {
      // Handle null/undefined input
      if (!yearValueCollection) {
        return "";
      }

      // Ensure we're working with an array
      if (!Array.isArray(yearValueCollection)) {
        return "";
      }

      let output = "";

      // Sort the yearValueCollection by year
      const sortedCollection = this.sortYearsValues(yearValueCollection);

      // Build output string
      sortedCollection.forEach((yearValue) => {
        if (
          yearValue &&
          yearValue.year != null &&
          yearValue.statsValue != null
        ) {
          output += `${yearValue.year}, ${yearValue.statsValue};`;
        }
      });

      return output;
    },
    CreateTextForNogaBranches(nogaBranchesSource, nogaBranchesToCompare) {
      var output = "";
      var allBranches = [];

      nogaBranchesSource.map((sourceBranch) => {
        if (!allBranches.includes(sourceBranch)) {
          if (nogaBranchesToCompare.includes(sourceBranch)) {
            var parentBranch = sourceBranch;
            var includesParentBranch = false;

            while (parentBranch) {
              parentBranch = this.GetParentNogaBranch(parentBranch);

              if (allBranches.includes(parentBranch)) {
                includesParentBranch = true;
                parentBranch = null;
              }
            }

            if (!includesParentBranch) {
              allBranches.push(sourceBranch);
            }
          }
        }
      });

      nogaBranchesSource.map((sourceBranch) => {
        if (
          !allBranches.includes(sourceBranch) &&
          !nogaBranchesToCompare.includes(sourceBranch)
        ) {
          var addBranch = false;

          var branchChildren = this.GetAllChildBranches(sourceBranch);

          branchChildren.map((childBranch) => {
            if (nogaBranchesToCompare.includes(childBranch)) {
              addBranch = true;
            }
          });

          var parentBranch = sourceBranch;
          var includesParentBranch = false;

          while (parentBranch) {
            parentBranch = this.GetParentNogaBranch(parentBranch);

            if (allBranches.includes(parentBranch)) {
              includesParentBranch = true;
              parentBranch = null;
            }
          }

          var parent = this.GetParentNogaBranch(sourceBranch);
          var grandParent = this.GetParentNogaBranch(parent);

          if (
            grandParent &&
            !allBranches.includes(grandParent) &&
            allBranches.includes(parent)
          ) {
            var siblings = this.GetImmediateChildBranches(parent);
            var compareBranchesHasSiblings = false;

            siblings.map((sibling) => {
              if (nogaBranchesToCompare.includes(sibling)) {
                compareBranchesHasSiblings = true;
              }
            });

            if (compareBranchesHasSiblings) {
              addBranch = true;
            }
          }

          if (addBranch || !includesParentBranch) {
            allBranches.push(sourceBranch);
          }
        }
      });

      allBranches.sort((a, b) => {
        return a - b;
      });

      allBranches.map((theBranch) => {
        var nogaBranch = this.allNogaBranches.filter((branch) => {
          return branch.nogaId == theBranch;
        });

        if (nogaBranch[0]) {
          output += `${" - ".repeat(nogaBranch[0].path.split("/").length)} ${
            nogaBranch[0].nogaCode
          } ${nogaBranch[0].value}\n`;
        }
      });

      return output;
    },
    GetParentNogaBranch(nogaId) {
      if (!nogaId) {
        return null;
      }

      var nogaBranch = this.allNogaBranches.filter((branch) => {
        return branch.nogaId == nogaId;
      });

      var parentBranch = this.allNogaBranches.filter((branch) => {
        return (
          branch.path ==
          nogaBranch[0].path.substring(nogaBranch[0].path.lastIndexOf("/"), 0)
        );
      });

      if (parentBranch[0]) {
        return parentBranch[0].nogaId;
      }

      return null;
    },
    GetImmediateChildBranches(nogaId) {
      var nogaBranch = this.allNogaBranches.filter((branch) => {
        return branch.nogaId == nogaId;
      });

      if (!nogaBranch[0]) {
        return [];
      }

      var childBranches = this.allNogaBranches.filter((branch) => {
        return (
          branch.path.indexOf(nogaBranch[0].path) == 0 &&
          (branch.path.replace(nogaBranch[0].path, "").match(/\//g) || [])
            .length == 1
        );
      });

      var children = [];

      childBranches.map((child) => {
        children.push(child.nogaId);
      });

      return children;
    },
    GetAllChildBranches(nogaId) {
      var allBranches = [];

      var immediatChildren = this.GetImmediateChildBranches(nogaId);
      allBranches = allBranches.concat(immediatChildren);

      immediatChildren.map((immediateChild) => {
        allBranches = allBranches.concat(
          this.GetAllChildBranches(immediateChild),
        );
      });

      return [...new Set(allBranches)];
    },
    async loadContractInformation() {
      if (this.isLoading) return;

      this.isLoading = true;
      this.noContractsSelected = false;
      this.ContractOne = null;
      this.ContractTwo = null;
      this.processedContracts.clear();

      if (this.contractInformations.length !== 2) {
        this.noContractsSelected = true;
        this.isLoading = false;
        return;
      }

      try {
        this.isLoading = true;
        await Promise.all([
          this.getAllContractInformation(this.contractInformations[0]),
          this.getAllContractInformation(this.contractInformations[1]),
        ]);
      } catch (error) {
        console.error("Error loading contract information:", error);
        this.errorObject = error;
        this.isLoading = false;
      } finally {
        this.isLoading = false;
        setTimeout(() => {
          this.allContractInfosLoaded = true;
        }, 500);
      }
    },
    async getAllContractInformation(contractEditionId) {
      try {
        const contractData = JSON.parse(contractEditionId);
        const {
          c: contractNumber,
          v: contractVersion,
          e: contractEdition,
        } = contractData;

        if (this.processedContracts.has(contractEditionId)) {
          return;
        }
        this.processedContracts.add(contractEditionId);

        const editionInfo = await new Promise((resolve, reject) => {
          GetSinlgeEdition(
            contractNumber,
            contractVersion,
            contractEdition,
            resolve,
            reject,
          );
        });

        const contractInfo = {
          EditionInfo: editionInfo,
          VersionInfo: {},
          ContractInfo: {
            contractNumber: contractNumber,
          },
          cantons: "",
          nogaBranches: [],
          PublicationInfo: {},
        };

        await this.getVersionInformationAsync(
          contractInfo,
          contractNumber,
          contractVersion,
        );
        await this.getContractInformationAsync(contractInfo, contractNumber);
        await this.getCantonsAsync(
          contractInfo,
          contractNumber,
          contractVersion,
          contractEdition,
        );
        await this.getNogaBranchesAsync(
          contractInfo,
          contractNumber,
          contractVersion,
          contractEdition,
        );
        await this.getPublicationsAsync(
          contractInfo,
          contractNumber,
          contractVersion,
        );

        await this.finalizeContractData(contractInfo);
      } catch (error) {
        console.error("Error in getAllContractInformation:", error);
        throw error;
      }
    },
    async getVersionInformationAsync(
      contractInfo,
      contractNumber,
      contractVersion,
    ) {
      return new Promise((resolve, reject) => {
        GetVersionInformation(
          contractNumber,
          contractVersion,
          (result) => {
            contractInfo.VersionInfo = result;
            resolve();
          },
          (error) => {
            contractInfo.VersionInfo = {};
            reject(error);
          },
        );
      });
    },
    async finalizeContractData(contractData) {
      if (!this.ContractOne) {
        this.ContractOne = { ...contractData };
      } else if (!this.ContractTwo) {
        if (this.ContractOne.EditionInfo.id < contractData.EditionInfo.id) {
          this.ContractTwo = { ...contractData };
        } else {
          this.ContractTwo = { ...this.ContractOne };
          this.ContractOne = { ...contractData };
        }
      }
    },

    async getContractInformationAsync(
      contractInfo,
      contractId,
      versionNumber,
      editionNumber,
    ) {
      GetContractInformation(
        contractId,
        (result) => {
          contractInfo.ContractInfo = result;
          this.getCantonsAsync(
            contractInfo,
            contractId,
            versionNumber,
            editionNumber,
          );
        },
        () => {
          contractInfo.ContractInfo = {};
          this.getCantonsAsync(
            contractInfo,
            contractId,
            versionNumber,
            editionNumber,
          );
        },
      );
    },
    async getCantonsAsync(
      contractInfo,
      contractId,
      versionNumber,
      editionNumber,
    ) {
      GetCantons(
        contractId,
        versionNumber,
        editionNumber,
        (response) => {
          contractInfo.cantons = "";

          if (response.length == 26) {
            contractInfo.cantons = "Alle Kantone";
          } else {
            response.map((canton) => {
              contractInfo.cantons += canton.value + "\n";
            });
          }

          this.getNogaBranchesAsync(
            contractInfo,
            contractId,
            versionNumber,
            editionNumber,
          );
        },
        () => {
          contractInfo.cantons = "";
          this.getNogaBranchesAsync(
            contractInfo,
            contractId,
            versionNumber,
            editionNumber,
          );
        },
      );
    },
    async getNogaBranchesAsync(
      contractInfo,
      contractId,
      versionNumber,
      editionNumber,
    ) {
      GetNogaBranchesForEdition(
        contractId,
        versionNumber,
        editionNumber,
        (response) => {
          contractInfo.nogaBranches = [];

          if (response && response.length > 0) {
            response.map((nogaBranch) => {
              contractInfo.nogaBranches.push(nogaBranch.nogaId);
            });
          }

          this.getPublicationsAsync(contractInfo, contractId, versionNumber);
        },
        () => {
          this.getPublicationsAsync(contractInfo, contractId, versionNumber);
        },
      );
    },
    async getPublicationsAsync(contractInfo, contractId, versionNumber) {
      GetAllPublications(
        contractId,
        versionNumber,
        (response) => {
          contractInfo.PublicationInfo = response;

          this.SortYears(contractInfo);
        },
        () => {
          contractInfo.PublicationInfo = {};
          this.SortYears(contractInfo);
        },
      );
    },
    SortYears(contractInfo) {
      const sortCompaniesPromise = new Promise((resolve) => {
        if (
          contractInfo.companiesUnderContract &&
          contractInfo.companiesUnderContract.length
        ) {
          resolve(this.sortYearsValues(contractInfo.companiesUnderContract));
        } else {
          resolve([]);
        }
      });

      const sortEmployeesPromise = new Promise((resolve) => {
        if (
          contractInfo.employeesUnderContract &&
          contractInfo.employeesUnderContract.length
        ) {
          resolve(this.sortYearsValues(contractInfo.employeesUnderContract));
        } else {
          resolve([]);
        }
      });

      Promise.all([sortCompaniesPromise, sortEmployeesPromise])
        .then(([sortedCompanies, sortedEmployees]) => {
          contractInfo.companiesUnderContract = sortedCompanies;
          contractInfo.employeesUnderContract = sortedEmployees;
          this.setAllContractValues(contractInfo);
        })
        .catch((error) => {
          console.error("An error occurred during sorting:", error);
        });
    },
    setAllContractValues(contractInfo) {
      if (!this.ContractOne) {
        this.ContractOne = { ...contractInfo };
      } else if (!this.ContractTwo) {
        if (this.ContractOne.EditionInfo.id < contractInfo.EditionInfo.id) {
          this.ContractTwo = { ...contractInfo };
        } else {
          this.ContractTwo = { ...this.ContractOne };
          this.ContractOne = { ...contractInfo };
        }
        this.isLoading = false;
      }
    },
  },
};
</script>

<style>
.comparisonTable {
  table-layout: fixed;
}

.comparisonTable td:nth-child(1),
.comparisonTable thead {
  font-weight: bold;
}

.comparisonTable td:nth-child(2) {
  background-color: rgb(245, 245, 245);
}

.comparisonTable td:nth-child(4) {
  border-left: solid gainsboro(211, 209, 209) 2px;
}

.comparisonTable td:nth-child(1) {
  width: 10%;
}

.comparisonTable td:nth-child(2) {
  width: 30%;
}

.comparisonTable td:nth-child(3) {
  width: 30%;
}

.comparisonTable td:nth-child(4) {
  width: 30%;
}

.comparisonTable td:nth-child(1),
.comparisonTable td:nth-child(2),
.comparisonTable td:nth-child(3) {
  border-right: solid gainsboro 1px;
}

.comparisonTable tr.newSection {
  border-top: solid gray 2px;
}

.comparisonTable thead td {
  border-top: none;
}

.comparisonTable ins {
  margin-left: 2px;
}

.comparisonTable .switchSymbol {
  color: gray;
  margin-left: 50%;
  font-size: 20px;
  font-weight: bold;
}
</style>
